

import logo_back from "../../../assets/fondo_mantenimiento.png"
//INCRIPTACION
import CryptoJS from "crypto-js";
import credit_card from "../../../components/shared/credit_card/credit_card.vue";

import $ from "jquery";
import { loadingOverlay } from "vuetify-more-component";
import { EncryptService } from "../../../utils/encrypthService";



export default {
  components: { credit_card, loadingOverlay },
  name: "Login",
  data() {
    return {
      formulario_back: '',
      logo_back,
      selecciona1: "card gr-2 rounded",
      selecciona2: "card gr-2 rounded",
      opt1: false,
      opt2: false,
      loading: false,
      validTributario: true,
      validPago: true,
      e1: 1,
      e2: 1,
      regimen: null,
      fecha_aux: "",
      nit: "",
      password: "",

      prueba: "",
      panel: [0, 1],


      tipoRegimen: [

      ],
      requisitos: {
        update_data_user: {
          password: "",
          regimen_id: "",
          fecha_nacimiento: "",
          presenta_retenciones: null,
          actividad_economica_id: null,
          recibe_ingresos_no_facturados: null,
          tipo_retencion: null,
          correo: null,
          otp: null
        },
        tarjeta: {
          nombre_portador: "",
          fecha_expiracion: "",
          contratos: false,
          no: "",
          cvv: null
        },

        suscripcion: 0,
        precio_suscripcion: null,
        descripcion_suscripcion: null,
        nombre_suscripcion: null,

        info_cupon: {
          id: null,
          descuento: null,
          precio_actual: null,
          nuevo_precio: null,
          tipo: null
      },

        cupon: null,
      },
      completo: true,

      usuario: null,

      loading_pago: false,

      colores: "#F1A300",
      menu2: false,
      date: '',
      show: true,

      suscripciones: [],

      dialog_cupon: false,
      cupon: null,

      items_perfil: [
      ],

      dialog_aceptar_suscripcion: false,
      referenceId_aux: null,


      lodingTipoEmisores: false,
      filas_emisores: [],
      tipo_emisores: [],
      columnas_emisores: [
        {
          text: "TIPO DE EMISOR",
          align: "center",
          sortable: true,
          value: "tipo_emisor.descripcion",
        },
        {
          text: "INCLUIR",
          align: "center",
          sortable: true,
          value: "incluir",
        }
      ],

      buscar_tipo_emisores: '',

      dialogDeseaExcluir: false,

      lodingEmisores: false,
      filas_NITemisores: [],

      excluidos: [],
      incluidos: [],
      col_incluidos: [{ value: "nit", text: "NIT", align: "center" },
      { value: "acciones", text: "acciones", align: "center" }],

      selectoExcluir: null,
      selectoIncluir: null,

      regimen_pc: false,
      regimen_ros: false,
      escoger_regimen: false,

      filas_tipo_perfil_declaracion: [],

      actividades_economicas: [],
      loading_actividades: false,

      passwordacceder: null,

      filas_tipo_emisores_activos: [],

      loading_datos_tributarios: false,

      loading_cupon: false,

      validOTP: false,
      changeEmail: false,
      baseEmail: null,
    };
  },

  async created() {
    sessionStorage.removeItem("CARD_INFO");
    sessionStorage.removeItem("CARD_REQUEST")

    $(document).ready(() => {
      $.ajax({

        "type": "GET",

        "url": "https://bacgateway.merchantprocess.net/SecureComponent/UIComponent/CreditCard",

        "data": { "APIKey": $("#txtAPIKey").val(), "Token": $("#txtToken").val(), "Culture": "es" },

        "success": function (jsonResponse) {

          $("#creditcard-container").html(jsonResponse);

          $("#creditcard-container").slideDown(500);
        }

      });

    });

    let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
    if (informacion_incriptada != null) {
      let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
      let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
      //Casteo de información a estring
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      //Casteo de JSON String a Object json
      let r = JSON.parse(informacion_desincriptada)
      // console.log("data encriptada");
      // console.log(r);
      this.usuario = r.usuario[0]
      console.log("usuario log", this.usuario);
      this.cargando_info = true;
      await this.getFaltantes();
      await this.getRegimenListado();

    }
  },

  mounted() {
    this.$watch(
      () => {
        return this.$refs.guardar;
      },
    );


  },

  watch: {

    date() {
      this.requisitos.update_data_user.fecha_nacimiento = this.date;
      this.fecha_aux = this.date.toString().split("-").reverse().join("/")
    },

    "requisitos.update_data_user.correo"() {
      if (this.requisitos.update_data_user.correo != this.baseEmail) {
        this.changeEmail = true;
      } else {
        this.changeEmail = false;
      }
    },
  },

  computed: {
    fechaExp() {
      let fecha = this.requisitos.tarjeta.fecha_expiracion.toString();
      fecha = fecha.split('-');
      return fecha[1] + '/' + fecha[0];
    },

    size() {
      const size = { xs: "x-small", sm: 'small', md: 'small', lg: 'small', xl: 'small' }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  },

  methods: {

    regresarAPago(){
      this.e1 = 4;
    },

    continuarResumen() {
      this.e1 = 6;
    },

    async validarOtp() {
      try {

        // valida que el formulario sea correcto formOTP
        if (!this.$refs.formOTP.validate()) {
          this.$toast.warning("Por favor, complete todos los campos requeridos del formulario de OTP", { position: "top-center", timeout: 5000 });
          return;
        }

        this.loading_cupon = true;
        let r = await this.$store.state.services.usuarioService.validarOtp({ token: this.requisitos.update_data_user.otp});
        console.log(r.data);
        if(r.data.success){
          this.continuarResumen();
        }else{
          this.$toast.warning(r.data.message, { position: "top-center", timeout: 5000 });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading_cupon = false;
      }
    },

    async actualizarCorreoPrimeraVez() {
      try {
        this.loading_cupon = true;
        let r = await this.$store.state.services.usuarioService.actualizarCorreoPrimeraVez({nuevo_correo: this.requisitos.update_data_user.correo});
        console.log(r.data);
        if(r.data.success){
          this.$toast.success("Correo actualizado correctamente, ahora ingresa el código OTP que te hemos enviado al nuevo correo para validar el cambio", { position: "top-center", timeout: 5000 });
        }else{
          this.$toast.warning(r.data.message, { position: "top-center", timeout: 5000 });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading_cupon = false;
        this.changeEmail = false;
      }
    },

    async getSuscripcionActual() {
      try {
        let r = await this.$store.state.services.usuarioService.getSuscripcionActual();
        console.log("suscripcion actual");
        if(r.data.data == null){
          this.usuario.regimen_id = 1;
          return;
        }

        this.usuario.regimen_id = r.data.data[0].tipo_suscripcion.regimen_id;
      } catch (error) {
        console.log(error);
      }
    },

    getMenu() {
      console.log(this.usuario.regimen_id);
      if (this.usuario.regimen_id == 1) {
        this.items_perfil =
          [{ text: 'Mi Perfil', icon: 'portrait', accion: "perfil", path: "/perfil_usuario/-1" },
          { text: 'Reporte Anual y Libro de Compras / Ventas', icon: 'event_note', accion: "cerrar", path: "/reporte_mensual_anual_usuario" },
          { text: 'Estado de declaración', icon: 'view_timeline', accion: "cerrar", path: "/estado_declaracion" },
          { text: 'Términos de Privacidad y Servicios', icon: 'privacy_tip', accion: "cerrar", path: "/terminos_privacidad_servicio" },
          { text: 'Otros Servicios', icon: 'workspaces', accion: "cerrar", path: "/servicios_extras" },
          ]
      } else if (this.usuario.regimen_id == 2) {
        this.items_perfil =
          [{ text: 'Mi Perfil', icon: 'portrait', accion: "perfil", path: "/perfil_usuario/-1" },
          { text: 'Reporte Anual y Libro de Compras / Ventas', icon: 'event_note', accion: "cerrar", path: "/reporte_mensual_anual_usuario" },
          { text: 'Estado de declaración', icon: 'view_timeline', accion: "cerrar", path: "/estado_declaracion" },
          { text: 'Términos de Privacidad y Servicios', icon: 'privacy_tip', accion: "cerrar", path: "/terminos_privacidad_servicio" },
          { text: 'Compras', icon: 'shopping_cart', accion: "", path: "/seleccion_facturas_compras" },
          { text: 'Perfil declaración', icon: 'settings_accessibility', accion: "", path: "/perfil_usuario/7" },


          ]
      }
    },

    async getTipoPerfilDeclaracion(actividad_economica_id) {
      try {
        this.loading_datos_tributarios = true;
        let r = await this.$store.state.services.usuarioService.getTipoPerfilDeclaracion(actividad_economica_id);
        this.loading_datos_tributarios = false;
        this.filas_tipo_perfil_declaracion = r.data.data;
        console.log("tipo perfil declaracion", this.filas_tipo_perfil_declaracion);
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener el tipo de perfil de declaración");
      }
    },

    async getTipoEmisorActivos() {
      try {
        let r = await this.$store.state.services.administradorService.getTipoEmisorActivos();
        this.filas_tipo_emisores_activos = r.data.data;
        console.log("tipo emisores activos", this.filas_tipo_emisores_activos);
      } catch (error) {
        console.log(error);
        this.$toast.erro("No es posible obtener los tipos de emisores activos")
      }
    },

    async getActividadEconomica() {
      try {
        this.loading_actividades = true;
        let r = await this.$store.state.services.administradorService.getListadoActividadEconomica();
        console.log("actividades economicas", r);
        this.loading_actividades = false;
        this.actividades_economicas = r.data.data;
      } catch (error) {
        this.loading_actividades = true;
        console.log(error);
        this.$toast.error("No es posible obtener las actividades economicas")
      }
    },

    elegir_tipo_regimen(item) {
      console.log(item);
      this.requisitos.update_data_user.regimen_id = item.id;

    },

    async aceptarSeleccion() {

      if (this.requisitos.update_data_user.regimen_id == 1) {
        this.regimen_pc = true;
        this.escoger_regimen = false;
        this.volver();
      } else if (this.requisitos.update_data_user.regimen_id == 2) {
        this.regimen_ros = true;
        this.escoger_regimen = false;
        await this.getActividadEconomica();
      } else {
        this.$toast.warning("Proximamente");
      }
      await this.getTiposSuscripcionActivas();
    },

    mover(item, tipo) {
      if (tipo == 1) {
        this.incluidos = this.incluidos.filter((x) => x.nit != item.nit)
        this.excluidos.push(item);
      } else {
        this.excluidos = this.excluidos.filter((x) => x.nit != item.nit)
        this.incluidos.push(item);
      }
    },

    regresarItemNITEmisores(item, tipo) {
      this.filas_NITemisores.push(item);
      if (tipo == 1) {
        this.incluidos = this.incluidos.filter((x) => x.nit != item.nit)
      } else {
        this.excluidos = this.excluidos.filter((x) => x.nit != item.nit)
      }
    },

    agregarIncluir() {
      if (this.selectoIncluir != null) {
        console.log(typeof (this.selectoIncluir), this.selectoIncluir);
        this.incluidos.push({ nit: this.selectoIncluir });
        this.filas_NITemisores = this.filas_NITemisores.filter((x) => x.nit != this.selectoIncluir);
        this.selectoIncluir = null;
        this.selectoExcluir = null;
      }
    },

    agregarExcluir() {
      console.log(this.selectoExcluir);
      if (this.selectoExcluir != null) {
        console.log(this.selectoExcluir);
        this.excluidos.push({ nit: this.selectoExcluir });
        this.filas_NITemisores = this.filas_NITemisores.filter((x) => x.nit != this.selectoExcluir);
        this.selectoExcluir = null;
        this.selectoIncluir = null;
      }
    },

    async getTipoEmisor() {
      try {
        this.lodingTipoEmisores = true;
        let r = await this.$store.state.services.administradorService.getTipoEmisor();
        console.log("getEmisor", r);

        this.filas_emisores = r.data.data.filter((x) => x.id != 1);

        this.tipo_emisores = this.filas_emisores;
        this.lodingTipoEmisores = false;
      } catch (error) {
        this.lodingTipoEmisores = false;
        console.log(error);
        this.$toast.error("No es posible listar los tipos de emisor")
      }
    },

    volver() {
      $(document).ready(function () {
        $.ajax({

          "type": "GET",

          "url": "https://bacgateway.merchantprocess.net/SecureComponent/UIComponent/CreditCard",

          "data": { "APIKey": $("#txtAPIKey").val(), "Token": $("#txtToken").val(), "Culture": "es" },

          "success": function (jsonResponse) {

            $("#creditcard-container").html(jsonResponse);

            $("#creditcard-container").slideDown(500);

            // let e =  document.getElementById("card-ui-component-btn-confirm");
            const boton = document.getElementById("card-ui-component-btn-confirm");
            boton.innerHTML = "Verificar tarjeta";

          }
        });
      });
    },

    retonar_seleccion_suscripcion() {
      // this.requisitos.precio_suscripcion = null;
      if (this.requisitos.update_data_user.regimen_id == 1) {
        this.e1 = 2;
      } else if (this.requisitos.update_data_user.regimen_id == 2) {
        this.e2 = 3;
      }
    },

    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },

    async getRegimenListado() {
      try {
        this.loading_regimenes = true;
        let r = await this.$store.state.services.administradorService.getRegimenListado();
        console.log("tipo regimen", r);
        this.escoger_regimen = true;
        this.tipoRegimen = r.data.data;
        this.requisitos.update_data_user.regimen_id = 1;
        this.loading_regimenes = false;

      } catch (error) {
        this.loading_regimenes = false;
        console.log(error);
        this.$toast.error("No es posible obtener los tipos de regímen")
      }
    },

    async getEmisores() {
      try {
        this.lodingEmisores = true;
        let r = await this.$store.state.services.administradorService.getListadoEmisores(-1);
        console.log("emisores", r);
        this.filas_NITemisores = r.data.data;
        this.lodingEmisores = false;
      } catch (error) {
        this.lodingEmisores = false;
        console.log(error);
        this.$toast.error("No es posible obtener los emisores")
      }
    },

    async tarjetaCredito(card) {

      if (this.requisitos.update_data_user.regimen_id == 1) {
        this.requisitos.tarjeta.nombre_portador = card.cardName;
        this.requisitos.tarjeta.contratos = card.checkbox;
        this.requisitos.tarjeta.cvv = card.cardCvv;
        if(this.baseEmail == null){
          this.e1 = 5;
          await this.obtenerCorreoUsuario();
        }else{
          this.e1 = 6;
        }
      } else if (this.requisitos.update_data_user.regimen_id == 2) {
        this.requisitos.tarjeta.nombre_portador = card.cardName;
        this.requisitos.tarjeta.contratos = card.checkbox;
        this.requisitos.tarjeta.cvv = card.cardCvv;
        this.e2 = 6;
      }

    },

    async obtenerCorreoUsuario() {
      try {
        this.loading_cupon = true;
        let r = await this.$store.state.services.usuarioService.getCorreoUsuario();
        console.log("correo usuario", r.data.data);
        this.requisitos.update_data_user.correo = r.data.data.correo;
        this.baseEmail = r.data.data.correo;
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener el correo del usuario")
      } finally {
        this.loading_cupon = false;
      }
    },

    atras() {
      console.log('LLEGO ATRAS');
      if (this.requisitos.update_data_user.regimen_id == 1) {
        this.e1 = 3;
      } else if (this.requisitos.update_data_user.regimen_id == 2) {
        this.e2 = 4;
      }
    },

    continuar_datos_tributarios() {
      //ROS
      this.e2 = 3;
      this.dialogDeseaExcluir = false

    },

    async valida_datos_tributarios() {
      if (this.$refs.formTributario.validate()) {
        if (this.requisitos.update_data_user.regimen_id == 2) {
          if (this.tipo_emisores.length != 0) {
            await this.getTipoPerfilDeclaracion(this.requisitos.update_data_user.actividad_economica_id)
            this.e2 = 2;
          } else {
            this.$toast.info("Debes seleccionar una o más categorias de emisor", { position: 'top-right' })
          }
        } else {
          this.e1 = 2;
        }
      } else {
        this.menu2 = false;
      }
    },

    async valida_suscripcion() {
      console.log(this.requisitos.suscripcion);

      if (this.requisitos.update_data_user.regimen_id == 1) {
        if (this.requisitos.suscripcion == 0) {
          this.$toast.info("Debes seleccionar un tipo de suscripción", { position: "top-center", timeout: 2000 })
        } else {
          this.e1 = 3
        }
      } else if (this.requisitos.update_data_user.regimen_id == 2) {

        if (this.requisitos.suscripcion == 0) {
          this.$toast.info("Debes seleccionar un tipo de suscripción", { position: "top-center", timeout: 2000 })
        } else {
          this.e2 = 4
          this.volver();
        }
      }

      if (this.requisitos.cupon == null) {
        this.dialog_cupon = true;
      }

    },

    verifica_tarjeta() {
      if (sessionStorage.getItem("CARD_REQUEST") != null) {
        let info = JSON.parse(atob(sessionStorage.getItem("CARD_REQUEST")))


        if (info.TokenDetails == null || info.TokenDetails == undefined) {
          this.$toast.error("No es posible obtener los datos de la tarjeta, da clic en botón de regresar y vuelve a ingresar otra tarjeta", { position: "top-center", timeout: 5000 })
          return;
        }


        if (this.requisitos.update_data_user.regimen_id == 1) {
          this.e1 = 4;
          this.$toast.success("Su tarjeta es válida , puede proceder a realizar el pago", { timeout: 5000 })
          console.log("esta es la información de mi tarjeta");
          this.requisitos.tarjeta.no = info.TokenDetails.CardNumber;
        } else if (this.requisitos.update_data_user.regimen_id == 2) {
          this.e2 = 5;
          this.$toast.success("Su tarjeta es válida , puede proceder a realizar el pago", { timeout: 5000 })
          console.log("esta es la información de mi tarjeta");
          this.requisitos.tarjeta.no = info.TokenDetails.CardNumber;
        }

      } else {
        console.log("no llenado el formulario");
        this.$toast.info("Debe verificar la tarjeta de crédito con el banco emisor, presione el botón 'Verificar Tarjeta'", { position: "top-right", timeout: 8000 });

      }
    },

    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },

    guardar_informacion() {
      this.dialog_aceptar_suscripcion = true;
    },

    revisarDeNuevo() {
      this.e1 = 1;
      this.e2 = 1;
      this.volver();
      sessionStorage.removeItem("CARD_INFO");
      sessionStorage.removeItem("CARD_REQUEST");
      this.requisitos.tarjeta.nombre_portador = "",
        this.requisitos.tarjeta.fecha_expiracion = "";
      this.requisitos.tarjeta.contratos = null;
      this.requisitos.tarjeta.no = null;
      this.requisitos.tarjeta.cvv = null;
    },

    async guardar_informacion_confirmar() {
      this.loading = true;
      try {
      const encryptService = new EncryptService();
      
        let info = JSON.parse(atob(sessionStorage.getItem("CARD_REQUEST")))
        console.log("esta es la información de mi tarjeta");
        console.log(info);
        let info_tarjeta = {
          token: info.TokenDetails.AccountToken,
          numero: info.TokenDetails.CardNumber,
          client: info.TokenDetails.CardHolderName,
          amount: this.requisitos.precio_suscripcion,
        }
        this.requisitos.info_tarjeta = info_tarjeta;
        this.requisitos.update_data_user.password = encryptService.encrypt(this.requisitos.update_data_user.password);

        if (this.requisitos.update_data_user.regimen_id == 2) {
          this.requisitos.tipo_emisores = this.filas_tipo_perfil_declaracion;
          this.requisitos.excluidos = this.excluidos;
          this.requisitos.incluidos = this.incluidos;
        }

        console.log("TERMINA ACA");
        console.log(this.requisitos);

        let r = await this.$store.state.services.loginService.postCompletar(this.requisitos);
        console.log(r);
        if (r.data.data == false) {
          this.loading = false;
          this.dialog_aceptar_suscripcion = false;
          this.$toast.error(r.data.message, { timeout: 5000 });
          sessionStorage.removeItem("CARD_INFO");
          sessionStorage.removeItem("CARD_REQUEST");
          this.e1 = 3;
          this.volver();
          this.$toast.error("No se ha realizado el cobro por motivos de error, vuelve a intentarlo.", { timeout: 5000 });
        } else {
          this.loading = false;
          this.e1 = 1;
          this.volver();
          sessionStorage.removeItem("CARD_INFO");
          sessionStorage.removeItem("CARD_REQUEST");
          this.requisitos.tarjeta.nombre_portador = "",
          this.requisitos.tarjeta.fecha_expiracion = "";
          this.requisitos.tarjeta.contratos = null;
          this.requisitos.tarjeta.no = null;
          this.requisitos.tarjeta.cvv = null;
          this.dialog_aceptar_suscripcion = false;
          await this.$toast.success("La información ha sido completada", { timeout: 5000 })
          await this.getFaltantes();
        }
      } catch (error) {
        sessionStorage.removeItem("CARD_INFO")
        this.dialog_aceptar_suscripcion = false;
        console.log(error);
        this.$toast.error("No es posible actualizar la información")
        this.loading = false;

        try {
          let r = await this.$store.state.services.usuarioService.postPagoVoid({ referenceId: this.requisitos.TransactionId });
          console.log("respuesta de void");
          console.log(r);
          let respuesta_void = this.parseXmlToJson(r.data);
          console.log("respuesta void");
          console.log(respuesta_void);

          if (respuesta_void.VoidResponse.VoidResult.Code === "00") {
            this.$toast.success("Reembolso realizado con éxito", { timeout: 5000 })

          } else {
            this.$toast.error("Error al realizar el reembolso , transacción: ", this.requisitos.TransactionId, { timeout: 10000 })
          }
        } catch (error) {
          console.log(error);
          this.$toast.error("Error al contactar con el servidor, para concluir el registro de la tarjeta de crédito", { timeout: 5000 })
        }
      }

      //recargo de la página
      location.reload();
    },

    async getFaltantes() {
      try {
        let r = await this.$store.state.services.usuarioService.getUsuarioFaltante(this.usuario.id);
        console.log("faltantes", r);
        if (r.data.success) {
          if (r.data.data.forma_pago.length == 0) {
            this.completo = false;
            // this.volver();
            await this.getTipoEmisor();
            await this.getTipoEmisorActivos();
            this.cargando_info = false;
          } else {
            console.log("ya esta completo");
            this.cargando_info = true;
            await this.getSuscripcionActual();
            this.cargando_info = false;
            this.completo = true;
            this.getMenu();
          }
        } else {
          this.$toast.error("Error al válidar la información ingresada")
          this.completo = false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    corregirFecha(fecha) {
      let fecha_correcta = "";
      const data = new Date(fecha);
      let dataDia = String(fecha);
      let dia = dataDia.split(" ")[2];
      let mes = data.getMonth() + 1;
      let año = data.getFullYear();
      fecha_correcta = String(año) + "-" + String(mes) + "-" + String(dia)
      if (fecha_correcta === "NaN-NaN-undefined") {
        fecha_correcta = ""
      }
      return fecha_correcta;
    },

    seleccionar_suscripcion(tipo) {
      console.log("seleccionar_suscripcion");
      setTimeout(() => {
        this.requisitos.suscripcion = null;
        this.requisitos.precio_suscripcion = null;
        this.requisitos.descripcion_suscripcion = null;
        this.requisitos.nombre_suscripcion = null
      }, 100);

      setTimeout(() => {
        console.log(tipo);
        this.suscripciones.forEach(suscripcion => {
      
            if (suscripcion.id == tipo.id) {
              this.requisitos.suscripcion = tipo.id
              this.requisitos.precio_suscripcion = tipo.precio;
              this.requisitos.descripcion_suscripcion = tipo.descripcion;
              this.requisitos.nombre_suscripcion = tipo.nombre
              tipo.selecciona = true;
            } else {
              suscripcion.selecciona = false;
            }
    
        });
      }, 100);
    },

    async getTiposSuscripcionActivas() {
      try {
        let r = await this.$store.state.services.administradorService.getTiposSuscripcionActivas(this.requisitos.update_data_user.regimen_id);
        console.log("suscripciones activas");
        console.log(r);
        let suscripciones = r.data.data
        // agrega la propiedad selecciona en false a cada objeto
        suscripciones.forEach(item => {
          item.selecciona = false;
        });
        let planes = [];
        console.log("suscripciones resumidas");
        console.log(planes);
        this.suscripciones = suscripciones;
        console.log(this.suscripciones);
      } catch (error) {
        console.log(error);
      }
    },

    async postPagoSuscripcionSale() {

      let info = JSON.parse(atob(sessionStorage.getItem("CARD_REQUEST")))
      console.log("esta es la información de mi tarjeta");
      console.log(info);

      let info_tarjeta = {
        token: info.TokenDetails.AccountToken,
        numero: info.TokenDetails.CardNumber,
        client: info.TokenDetails.CardHolderName,
        amount: this.requisitos.precio_suscripcion,
        cvv: this.requisitos.tarjeta.cvv
      }

      if( this.requisitos.precio_suscripcion == 0){
        this.requisitos.TransactionId = 0;
        await this.guardar_informacion_confirmar();
        return;
      }

      console.log("info tarjeta");
      console.log(info_tarjeta);
      try {
        this.loading = true;
        let r = await this.$store.state.services.usuarioService.postPagoSuscripcionSale(info_tarjeta);
        console.log(r);

        if (r.data.data == false) {
          this.loading = false;
          this.dialog_aceptar_suscripcion = false;
          this.$toast.error(r.data.message, { timeout: 5000 });
          sessionStorage.removeItem("CARD_INFO");
          return;
        }

        let respuesta = this.parseXmlToJson(r.data);
        console.log("respuesta");
        console.log(respuesta);

        if (respuesta.SaleResponse.SaleResult.Code === "00") {
          this.requisitos.TransactionId = respuesta.SaleResponse.SaleResult.TransactionId
          this.requisitos.amount = this.requisitos.precio_suscripcion;
          this.$toast.success("Pago realizado con éxito", { timeout: 5000 })
          this.loading = false;
          await this.guardar_informacion_confirmar();
        } else {
          this.loading = false;
          this.e1 = 3;
          if (respuesta.SaleResponse.SaleResult.Code === "51") {
            this.$toast.error("Error al realizar el pago, Fondos insuficientes", { timeout: 5000, position: "top-right" })
          } else if (respuesta.SaleResponse.SaleResult.Code === "05") {
            this.$toast.error("Error al realizar el pago, Tajerta declinada, contacte al proveedor de la tarjeta de crédito", { timeout: 5000, position: "top-right" })
          } else if (respuesta.SaleResponse.SaleResult.Code === "111") {
            this.$toast.error("Error al realizar el pago, Transacción denegada TID inválido", { timeout: 5000, position: "top-right" })
          } else if (respuesta.SaleResponse.SaleResult.Code === "57") {
            this.$toast.error("Error al realizar el pago, Tarjeta bloqueada o cancelada por el banco", { timeout: 5000, position: "top-right" })
          } else if (respuesta.SaleResponse.SaleResult.Code === "132") {
            this.$toast.error("Error al realizar el pago, Declinada, tarjeta reportada como perdida/robada", { timeout: 5000, position: "top-right" })
          } else {
            this.$toast.error("Error al realizar el pago con tarjeta ingresada" + respuesta.SaleResponse.SaleResult.Code, { timeout: 5000, position: "top-right" })
          }
          sessionStorage.removeItem("CARD_REQUEST");
          this.volver();
          this.dialog_aceptar_suscripcion = false;
          sessionStorage.removeItem("CARD_INFO");
          sessionStorage.removeItem("CARD_REQUEST");
          this.requisitos.tarjeta.nombre_portador = "",
            this.requisitos.tarjeta.fecha_expiracion = "";
          this.requisitos.tarjeta.contratos = null;
          this.requisitos.tarjeta.no = null;
          this.requisitos.tarjeta.cvv = null;
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("Error al realizar el pago, verifique los datos de su tarjeta de crédito", { timeout: 5000 })
        sessionStorage.removeItem("CARD_REQUEST");
        this.volver();
        this.e1 = 3;
      }
    },

    parseXmlToJson(xml) {
      const json = {};
      for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
        const key = res[1] || res[3];
        const value = res[2] && this.parseXmlToJson(res[2]);
        json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;

      }
      return json;
    },

    async validarCupon() {
      console.log("validar cupon");
      try {
        this.loading_cupon = true;
        const body = {
          precio: this.requisitos.precio_suscripcion,
          cupon: this.cupon
        }
        let r = await this.$store.state.services.usuarioService.canjearCupon(body);
        console.log("respuesta cupon");
        console.log(r);
        this.requisitos.cupon = null;

        if (r.data.success == false) {
          this.$toast.error(r.data.message, { timeout: 5000 });
          this.cupon = null;
        } else {
          this.requisitos.precio_suscripcion = r.data.data.nuevo_precio;
          this.requisitos.cupon = true;
          this.requisitos.info_cupon.id = r.data.data.id;
          this.requisitos.info_cupon.descuento = r.data.data.descuento;
          this.requisitos.info_cupon.precio_actual = r.data.data.precio_actual;
          this.requisitos.info_cupon.nuevo_precio = r.data.data.nuevo_precio;
          this.requisitos.info_cupon.tipo = r.data.data.tipo;
          this.$toast.success("Descuento aplicado en su suscripción", { timeout: 5000, position: "bottom-center" });
          this.dialog_cupon = false;
        }

      } catch (error) {
        console.log(error);
        this.$toast.error("Error al validar el cupon o el cupon no existe", { timeout: 5000 });
      } finally {
        this.loading_cupon = false;
      }
    },

    omitirCupon() {
      console.log("omitir cupon");
      this.requisitos.cupon = null;
      this.dialog_cupon = false;
    },
  }
};